import styles from '@ui/components/BlogCard/BlogCard.module.scss';
import Card from '@ui/components/Card/Card';
import Content from '@ui/components/Content/Content';
import Heading from '@ui/components/Heading/Heading';
import Link from '@ui/components/Link/Link';
import CardImage from '@ui/components/Card/components/CardImage/CardImage';
import CardBody from '@ui/components/Card/components/CardBody/CardBody';
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getHeadingTag } from '../../utils';

const BlogCard = ({
  title,
  image,
  headingLevel = 3,
  excerpt,
  link,
  date,
  className = null,
  name = null,
  target = '_self',
}) => (
  <Card
    as={Link}
    className={classNames(styles.container, className)}
    target={target}
    to={link}
  >
    {image && <CardImage height={285} image={image} />}
    <CardBody className={styles.body}>
      <div>
        <Heading
          as={getHeadingTag(headingLevel)}
          className={styles.title}
          size="h6"
          withParser
        >
          {title}
        </Heading>
        <Content className={styles.content} withParser>
          {excerpt}
        </Content>
      </div>
      <div className={styles.footer}>
        {name && (
          <Content className={classNames(styles.footerElement, styles.name)}>
            {name}
          </Content>
        )}
        <Content className={classNames(styles.footerElement, styles.date)}>
          {date}
        </Content>
      </div>
    </CardBody>
  </Card>
);

BlogCard.propTypes = {
  className: PropTypes.string,
  date: PropTypes.string.isRequired,
  excerpt: PropTypes.string.isRequired,
  headingLevel: PropTypes.number,
  image: PropTypes.shape({
    alt: PropTypes.string,
    src: PropTypes.string.isRequired,
    srcSet: PropTypes.string,
  }).isRequired,
  link: PropTypes.string.isRequired,
  name: PropTypes.string,
  target: PropTypes.oneOf(['_blank', '_self', '_parent', '_top']),
  title: PropTypes.string.isRequired,
};

export default BlogCard;
